import type { GInfoPanelLeftColumnProps } from './GInfoPanelLeftColumn';

import { GInfoPanelSingleItem } from './GInfoPanelSingleItem';
import { BlockStack, Box } from '@shopify/polaris';

interface GInfoPanelItemProps extends Pick<
  GInfoPanelLeftColumnProps,
  'items' | 'selectedId' | 'selectedBackground' | 'onSelect' | 'onHover'
> {}

export const GInfoPanelSingle: React.FC<GInfoPanelItemProps> = ({
  items,
  selectedId,
  selectedBackground,
  onSelect,
  onHover,
}) => {
  if (items.length === 0) return null;

  return (
    <Box padding="150">
      <BlockStack gap="0">
        {items.map((item) => (
          <GInfoPanelSingleItem
            key={item.id}
            item={item}
            isSelected={selectedId === item.id}
            selectedBackground={selectedBackground}
            onSelect={onSelect}
            onHover={onHover}
          />
        ))}
      </BlockStack>
    </Box>
  );
};
